import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { SmMetaModel } from 'common/models/utility-models/meta-model';
import { EmailTemplateModel } from 'common/models/page-models/Email-Template/email-template-data-model';
import { EmailTemplateListingModel } from 'common/models/page-models/Email-Template/email-template-grid-model';
import { EmailTemplateGridMetaModel } from 'common/models/page-models/Email-Template/email-template-grid-meta-model';
import { EmailTemplateGridDataService } from 'common/services/data-services/admin/email-template/email-template-grid-data.service';

 
@Injectable({
    providedIn: 'root'
})
export class EmailTemplateGridWidgetService extends GridWidgetService<EmailTemplateModel, EmailTemplateListingModel> {
    constructor(protected override ds: EmailTemplateGridDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    createQueryParams(queryParam): GridParams {
        for (const key in queryParam) {
            this.queryparm[key] = queryParam[key];
        }
        return this.queryparm;
    }
 
    getMetaModel(): MetaModel {
        const meta = new EmailTemplateGridMetaModel().getMetaModel();
        return meta;
    }

}